import { createReducer, isAnyOf } from "@reduxjs/toolkit";

import {
  getCreatorProfile,
  getCreatorProfileSuccess,
  getCreatorProfileFailure,
  blockCreatorSuccess,
  unblockCreatorSuccess,
  getCreatorProfileReset,
  followCreatorSuccess,
  unfollowCreatorSuccess,
  setCreatorSubscription,
  dontShowReport,
  dontShowReportSuccess,
  dontShowReportFailure,
  setCreatorSubscriptionPortion,
  setConversation,
} from "./actions";
import { likePostSuccess, unlikePostSuccess } from "../posts/actions";

const initialState = {
  id: undefined,
  createdAt: undefined,
  updatedAt: undefined,
  username: undefined,
  email: undefined,
  name: undefined,
  bio: undefined,
  dob: undefined,
  country: undefined,
  socialLinks: [],
  avatar: undefined,
  banner: undefined,
  followersCount: undefined,
  followingsCount: undefined,
  promotersCount: undefined,
  supportersCount: undefined,
  postsCount: undefined,
  subscription: undefined,
  error: null,
  isMessagingAvailable: undefined,
  isReportsNotificationShown: undefined,
  isLoading: false,
  isBlocked: undefined,
  isBlockedByUser: undefined,
  isBlockedByYou: undefined,
  isFollowed: undefined,
  likesCount: undefined,
  stripeAccountId: undefined,
  totalCount: undefined,
  nextOffset: undefined,
  conversationId: undefined, // exists if you have chat w/ this user
  activeStream: undefined,
  allPosts: [],
  postById: {},
  isLoadingNext: false,
  isLoadingFirstTime: false,
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(unlikePostSuccess.type, (state, { payload }) => {
      return {
        ...state,
        likesCount:
          payload.creatorId === state.id
            ? state?.likesCount - 1
            : state?.likesCount,
      };
    })
    .addCase(likePostSuccess.type, (state, { payload }) => ({
      ...state,
      likesCount:
        payload.creatorId === state.id
          ? state?.likesCount + 1
          : state?.likesCount,
    }))
    .addCase(getCreatorProfile.type, (state) => ({
      ...state,
      isLoading: true,
    }))
    .addCase(getCreatorProfileSuccess.type, (_state, { payload }) => ({
      ..._state,
      ...payload,
      isLoading: false,
    }))
    .addCase(getCreatorProfileFailure.type, (state, action) => ({
      ...state,
      isSuccess: false,
      isLoading: false,
      error: action.payload,
    }))
    .addCase(getCreatorProfileReset.type, () => ({
      ...initialState,
      isLoading: true,
    }))
    .addCase(
      setCreatorSubscription.type,
      (state, { payload: { subscription, totalCount, nextOffset } }) => ({
        ...state,
        subscription: subscription,
        totalCount: totalCount,
        nextOffset: nextOffset,
      }),
    )
    .addCase(setCreatorSubscriptionPortion.type, (state, { payload }) => {
      const { subscription = [] } = state;
      const {
        subscription: newSubscriptionById,
        totalCount,
        nextOffset,
      } = payload;

      return {
        ...state,
        subscription: [...subscription, ...newSubscriptionById],
        totalCount,
        nextOffset,
        error: initialState.error,
        isLoading: false,
      };
    })
    .addCase(dontShowReport.type, (state) => ({
      ...state,
      isLoading: true,
    }))
    .addCase(dontShowReportSuccess.type, (state) => ({
      ...state,
      isReportsNotificationShown: false,
      isLoading: false,
    }))
    .addCase(dontShowReportFailure.type, (state, action) => ({
      ...state,
      isSuccess: false,
      isLoading: false,
      error: action.payload,
    }))
    .addCase(setConversation.type, (state, { payload }) => {
      const { conversationId, opponentId } = payload;

      if (state.id == opponentId) {
        state.conversationId = conversationId;
      }
    })
    .addMatcher(
      isAnyOf(followCreatorSuccess, unfollowCreatorSuccess),
      ({ id, isFollowed, ...state }, { payload }) => {
        const { userId } = payload;

        return {
          id,
          ...state,
          isFollowed: id === userId ? !isFollowed : isFollowed,
          isLoading: false,
        };
      },
    )
    .addMatcher(
      isAnyOf(blockCreatorSuccess, unblockCreatorSuccess),
      ({ id, isBlockedByYou, ...state }, { payload }) => {
        const { userId } = payload;

        return {
          id,
          ...state,
          isBlockedByYou: id === userId ? !isBlockedByYou : isBlockedByYou,
        };
      },
    );
});
